<template lang="pug">
span(:class="cssClass + ' ' + $attrs.class")
  template(v-if="format === 'currency'") {{ formatUtil.currency(showNumber) }}
  template(v-else-if="format === 'percent' || format === 'rate'") 
    span {{ formatUtil.number(showNumber, decimals ?? 2) }}
    span(style="margin-left: 0.15em;") %
  template(v-else) {{ formatUtil.number(showNumber, decimals ?? 2) }}
</template>

<script setup>
import { computed } from 'vue'
import { format as formatUtil } from '@/utils/format'

const props = defineProps({
  number:   { type: Number, required: false },
  format:   { type: String, required: false, default: 'currency' },
  invert:   { type: Boolean, default: false },
  inactive: { type: Boolean, default: false },
  decimals: { type: Number, default: null },
})

const originalNumber = computed(() => props.number)
const showNumber = computed(() => props.invert ? (0 - originalNumber.value) : originalNumber.value)

const isPositive = computed(() => showNumber.value > 0)
const isNegative = computed(() => showNumber.value < 0)
const isZero     = computed(() => showNumber.value == 0)

const cssClass = computed(() => {
  const base = isPositive.value ? 'num-positive'
    : isNegative.value ? 'num-negative'
    : 'num-zero'
  return props.inactive ? `${base} num-inactive` : base
})
</script>

<style scoped lang="scss">
.num-positive {
  color: var(--green-800);
}
.num-negative {
  color: var(--orange-600);
}
.num-zero {
  color: gray;
}
.num-inactive {
  text-decoration-line: line-through;
}
</style>
